import * as React from "react";
import { useTranslation } from 'react-i18next';
import IconButton from "../../components/button/IconButton";

export const useTableColumns = () => {
    const { t } = useTranslation();
    
    return [
        {
            label: t("common.internal_number"),
            field: "internalNumber",
            sort: "asc",
            width: 200,
        },
        {
            label: t("common.line_name"),
            field: "name",
            sort: "desc",
            width: 150,
        },
        {
            label: t("common.packing_system"),
            field: "packingSystem",
            type: "badge",
            sort: "desc",
            width: 150,
        },
        {
            label: t("common.status"),
            field: "machineType",
            type: "enum",
            enumType:"enums/packingSystem",
            sort: "desc",
            width: 200,
        }
    ];
};

export default useTableColumns;